import { activityRecordTypeForGoalMetricItemLinkKind } from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferRouterOutputs } from "@trpc/server";
import {
    ActivityFeedRowBody,
    ActivityRowRelations,
} from "components/details-page-v-next/activity-rows";
import { feedItemDisplay } from "components/details-page-v-next/recent-activities-feed";
import React from "react";
import { contactRelations, organizationRelation } from "./activity-relations";
import { goalMetricItemHref } from "./goal-metric-item";

type RecentActivityItem =
    inferRouterOutputs<AppRouter>["marketingGoal"]["recentActivityForRange"][number];

const rowParentLink = (item: RecentActivityItem): React.ReactNode => {
    if (item.redaction === "deleted") {
        return <span className="text-xs italic text-gray-500">Deleted record</span>;
    }
    if (item.redaction === "otherOffice") {
        return <span className="text-xs italic text-gray-500">In another office</span>;
    }
    if (item.link && item.parentName) {
        return (
            <ActivityRowRelations
                href={goalMetricItemHref(item.link)}
                parentName={item.parentName}
                recordType={activityRecordTypeForGoalMetricItemLinkKind[item.link.kind]}
                organization={organizationRelation(item.organization)}
                involvedContacts={contactRelations(item.involvedContacts)}
            />
        );
    }
    if (item.parentName) {
        return <span className="text-xs text-gray-500">{item.parentName}</span>;
    }
    return null;
};

export const RecentActivityRow: React.FC<{ item: RecentActivityItem }> = ({ item }) => (
    <ActivityFeedRowBody
        display={{ ...feedItemDisplay(item), link: rowParentLink(item) }}
        actions={null}
    />
);
